import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AppState } from '../app.service';
import { Client } from '../client/client.model';
import { UtilityService } from '../common-services/utility.service';
import { ContentSurveyStats } from '../content-survey/content-survey.model';
import { DailyStepsService } from '../daily-steps/daily-steps.service';
import { MyCommitmentsComponent } from '../my-commitments/my-commitments.component';
import { HomeUiService } from '../new-design/home-ui.service';
import { HomeV5Service } from '../pages/home-v5/home-v5.service';
import { Path } from '../path/path-v2.model';
import { StatListComponent } from '../stat/stat-list.component';
import { StatService } from '../stat/stat.service';
import { ThemeService } from '../theme/theme.service';
import { User } from '../user/user.model';
import { WalletService } from '../wallet/wallet.service';
import { CloseoutSurveyComponent } from './closeout-survey.component';
import { KyperDataApiService } from '../services/kyper-data-api.service';
import { AllPathsV2Component } from '../all-paths-v2/all-paths-v2.component';

  export interface ChartSettings {
  colour: string
  labels: string[]
  data: any
  greenDays: number[]
  realDay: number
}
@Component({
  selector: 'app-closeout-survey-welcome',
  templateUrl: './closeout-survey-welcome.component.html',
  styleUrls: ['./closeout-survey-welcome.component.scss']
})
export class CloseoutSurveyWelcomeComponent implements OnInit {
  currentPath: Path
  currentClient: Client
  currentUser: User
  chartSettings: ChartSettings
  leaderboardPosition: string
  badgesCount: number
  graphLabels:any
  graphData:any
  graphGreen:any
  graphRealDay:any
  firstSurveyStats: ContentSurveyStats
  finalSurveyStats: ContentSurveyStats
  allowScreenCount: boolean
  stats: any;
  thisPathUserRank: any
  thisPathUser:any;
  makePath: boolean=false;
  scheduleDay:any;
  isShow=false;
  isMobile;
  dailyStepsArray;
  scheduledStep;
  totalTodoRoutines = []
  totalActions = []
  totalTodoRoutinesRepsCount = 0;
  totalActionsCompletedCount = 0;
  routineInfo;
  constructor(
    private appState: AppState,
    private router: Router,
    private statService: StatService,
    private themeService: ThemeService,
    public homeUIService: HomeUiService,
    public walletService: WalletService,  // LUMBA-1403
    private utilService: UtilityService,
    private modalController: ModalController,
    private cdRef: ChangeDetectorRef,
    private homev5Service: HomeV5Service,
    private kyperApiService: KyperDataApiService,
    private dailyStepsService: DailyStepsService
  ) {
    this.currentPath = this.appState.get('currentPath')
    this.currentUser = this.appState.get('currentUser');
    this.currentClient = this.appState.get('currentClient');
    this.scheduleDay = +this.appState.get('currentScheduleDay');
    this.themeService.setTheme(this.currentPath.getTheme())
    this.allowScreenCount = this.appState.get('allowScreenCount')
    this.isMobile = this.appState.get('isMobile');
    this.init()
    setTimeout(()=>{this.isShow=true}, 100);
  }
 
  getActions(pathId: number) {
    const requestData = {
      'path_id': pathId
    }
    this.kyperApiService.getActionsList(requestData).subscribe((response) => {
      this.appState.set('todoActions', response.actions)
      this.appState.set('completedActions',  response.actions.filter(item => item.userActionCompletion))
      this.totalActions =  response.actions.filter(item => item.userActionCompletion && item.id)
      this.totalActionsCompletedCount = this.totalActions?.length;
      console.log("total actions count", this.totalActionsCompletedCount);     
    }, (error) => {
      console.log('error :', error);
    })
  }
   getRoutines(pathId: number) {
    const requestData = {
      'path_id': pathId
    }
    this.kyperApiService.getHabitsList(requestData).subscribe((response) => {
      this.appState.set('todoRoutines', this.homev5Service.removeDuplicates(response.routines, "habitGroupId"))
      this.totalTodoRoutines = this.homev5Service.removeDuplicates(response.routines, "habitGroupId")
      this.totalTodoRoutines?.forEach((routine) => {
        routine?.habits?.forEach((level) => {
          let completedreps = level?.repsData.filter(item => item.is_completed === true)
          if (completedreps?.length>0) {
            this.totalTodoRoutinesRepsCount = this.totalTodoRoutinesRepsCount + completedreps?.length;
          }
          console.log("total reps count is", this.totalTodoRoutinesRepsCount, completedreps)
        })
      });
    }, (error) => {
      console.log('error :', error);
    })
  }
  /**
   * The step at a position, searched across chapters.
   *
   * Step positions are global across the path, so they cannot index the chapter array.
   */
  findStepByPosition(dailyStepsArray: any, position: number) {
    for (const chapter of dailyStepsArray ?? []) {
      const step = (chapter?.steps ?? []).find((candidate: any) => candidate?.position === position)
      if (step) { return step }
    }
    return null
  }

  ngOnInit() {

    this.getActions( this.currentPath?.id)
    this.getRoutines( this.currentPath?.id)
    this.scheduledStep =this.appState.get('currentDayAfterScreenView')
    this.dailyStepsArray = this.appState.get("DailyStepsData");
    // this.routineInfo = this.fetchScreenTypeContent('routineInfo');
    // Resolved by position: DailyStepsData holds CHAPTERS and step positions are global across the
    // path, so `[scheduledStep - 1]` read a chapter, whose stepStatus is always undefined — the
    // 'Review' clause never blocked anything.
    const stepInHand = this.findStepByPosition(this.dailyStepsArray, this.scheduledStep)
    if (this.allowScreenCount && this.scheduleDay ==this.scheduledStep && stepInHand && stepInHand.stepStatus!='Review'){
      this.utilService.setScreenCount()
    }
  }
  fetchScreenTypeContent(screentype) {
    let dailyStepsArray = this.appState.get('DailyStepsData')
    return dailyStepsArray
  .map(step => step?.[screentype])
  .filter(s => s != null && (Array.isArray(s) ? s?.length > 0 : true))
  .flatMap(s => Array.isArray(s) ? s : [s]);
  }
  toggleTheme() {
    this.homeUIService.toggleTheme();
    this.cdRef.detectChanges(); 
  }
  
  init(){
    // this.statService.getKyperUserParticipation().subscribe(
    //   response => {
    //     // const cutResponse = this.statService.cutParticipationData(response?.data);
    //     // this.chartSettings = {
    //     //   colour: this.currentPath.colours['theme'],
    //     //   labels: cutResponse?.labels,
    //     //   data: cutResponse?.data,
    //     //   greenDays: response?.greenDays,
    //     //   realDay: response?.realDay
    //     // }
        
    //     // this.leaderboardPosition = response.leaderboardPosition
    //     // this.badgesCount = response.badgesCount
    //     const firstSurvey = this.statService.findFirstCompletedSurvey(this.fetchScreenTypeContent('contentSurveys'));
    //     const finalSurvey = this.statService.findFinalCompletedSurvey(this.fetchScreenTypeContent('contentSurveys'));
    //     if (firstSurvey) {
    //       this.firstSurveyStats = firstSurvey.getStats()
    //     }
    //     if (finalSurvey) {
    //       this.finalSurveyStats = finalSurvey.getStats()
    //     }
    //   }
      
    // )
    this.getStats();
  }

  goToSurvey() {
    // Resolved by position: DailyStepsData holds CHAPTERS and step positions are global across the
    // path, so `[scheduledStep - 1]` read a chapter, whose stepStatus is always undefined — the
    // 'Review' clause never blocked anything.
    const stepInHand = this.findStepByPosition(this.dailyStepsArray, this.scheduledStep)
    if (this.allowScreenCount && this.scheduleDay ==this.scheduledStep && stepInHand && stepInHand.stepStatus!='Review'){
      this.utilService.setScreenCount()
    }
    // this.router.navigate(['/closeout'])
    this.modalController.dismiss();
    this.homeUIService.openDailyStepsComponent(CloseoutSurveyComponent,'','web-daily-steps-custom-modal')
  }
  getStats() {
    this.statService.getLeaderboardKyperList(this.currentPath.id)
      .subscribe(response => {
        this.stats = response?.data;
        this.getCurrentUser(this.stats);
      }
      ,(error) => {
        this.stats = error
      })

  }
  getCurrentUser(stats: any) {
    var current_path_user = []
    current_path_user = stats?.['this_path']
    let currentUserStats = stats?.current_user_positions;
    let userPosition =stats?.user_position?.length>0?stats?.user_position[0]:stats?.user_position
    try {
      // this.thisPathUserRank = current_path_user.findIndex(element => element.isMe)
      // let thisUser = current_path_user.filter(element => element.isMe)
      // this.thisPathUser = thisUser[0];
       this.thisPathUserRank = currentUserStats?.current_path_position;
      this.thisPathUser = { ...userPosition }
      this.thisPathUser.actionPoints =currentUserStats?.current_path_action_points
    } catch (error) {
      console.log('error catch', error);

    }
  }
  getClass(){
    return true;
  }
  goToLeaderBoard(){
    //this.router.navigate(['/main/stats'])
    this.homeUIService.openNextComponent(StatListComponent);

  }
  gotoMyCommitment(){
   // this.router.navigate(['/main/commitments'])
   this.homeUIService.openNextComponent(MyCommitmentsComponent)
  }
  goToNewPath(){
    // this.router.navigate(['/main/stats'])
    this.homeUIService.openNextComponent(StatListComponent);
  }
  setClass(value) {
     this.appState.set("isAllPaths", true);
    this.homeUIService.openNextComponent(AllPathsV2Component)
    //this.makePath=value;
  }
  goToHome(){
    this.router.navigate(['/main'])
  }
  openAllPathsModal() {
    this.appState.set("isAllPaths", true);
    this.modalController.dismiss();
    setTimeout(()=>{
      this.homeUIService.openNextComponent(AllPathsV2Component, '', 'desktop-allpath');
    },550)
  }
  openToDoListModal() {
    this.modalController.dismiss();
    setTimeout(()=>{
      this.homeUIService.openNextComponent(MyCommitmentsComponent,'','desktop-todo')
    },550)
  }
  close() {
    this.modalController.dismiss();
  }
}
